const defaultThemeConfig = {
	_version: 2,
	avatar: {
		sizes: [
			{
				distance: -4,
				size: 19
			},
			{
				distance: -4,
				size: 25
			},
			{
				distance: -8,
				size: 33
			},
			{
				distance: -12,
				size: 49
			}
		],
		focusRing: {
			offset: 1,
			width: 1
		}
	},
	button: {
		textWeight: "medium",
		border: { width: 1 },
		focusRing: {
			offset: -1,
			width: 1
		}
	},
	card: {
		border: { width: 1 },
		focusRing: {
			offset: -1,
			width: 1
		},
		shadow: { outline: .5 }
	},
	container: [
		320,
		640,
		960,
		1280,
		1600,
		1920
	],
	media: [
		360,
		600,
		900,
		1200,
		1800,
		2400
	],
	layer: {
		dialog: { zOffset: 600 },
		popover: { zOffset: 400 },
		tooltip: { zOffset: 200 }
	},
	radius: [
		0,
		1,
		3,
		6,
		9,
		12,
		21
	],
	shadow: [
		null,
		{
			umbra: [
				0,
				0,
				0,
				0
			],
			penumbra: [
				0,
				0,
				0,
				0
			],
			ambient: [
				0,
				0,
				0,
				0
			]
		},
		{
			umbra: [
				0,
				3,
				5,
				-2
			],
			penumbra: [
				0,
				6,
				10,
				0
			],
			ambient: [
				0,
				1,
				18,
				1
			]
		},
		{
			umbra: [
				0,
				7,
				8,
				-4
			],
			penumbra: [
				0,
				12,
				17,
				2
			],
			ambient: [
				0,
				5,
				22,
				4
			]
		},
		{
			umbra: [
				0,
				9,
				11,
				-5
			],
			penumbra: [
				0,
				18,
				28,
				2
			],
			ambient: [
				0,
				7,
				34,
				6
			]
		},
		{
			umbra: [
				0,
				11,
				15,
				-7
			],
			penumbra: [
				0,
				24,
				38,
				3
			],
			ambient: [
				0,
				9,
				46,
				8
			]
		}
	],
	space: [
		0,
		4,
		8,
		12,
		20,
		32,
		52,
		84,
		136,
		220
	],
	input: {
		border: { width: 1 },
		checkbox: {
			size: 17,
			focusRing: {
				offset: -1,
				width: 1
			}
		},
		radio: {
			size: 17,
			markSize: 9,
			focusRing: {
				offset: -1,
				width: 1
			}
		},
		switch: {
			width: 25,
			height: 17,
			padding: 5,
			transitionDurationMs: 150,
			transitionTimingFunction: "ease-out",
			focusRing: {
				offset: 1,
				width: 1
			}
		},
		select: { focusRing: {
			offset: -1,
			width: 1
		} },
		text: { focusRing: {
			offset: -1,
			width: 1
		} }
	},
	style: { button: { root: { transition: "background-color 100ms,border-color 100ms,color 100ms" } } }
}, cache$1 = /* @__PURE__ */ new WeakMap();
/** @internal */
function themeColor_v0_v2(color_v0) {
	let cached_v2 = cache$1.get(color_v0);
	if (cached_v2) return cached_v2;
	let base = stateThemeColor_v0_v2(color_v0, color_v0.card.enabled), color_v2 = {
		_blend: color_v0._blend || (color_v0.dark ? "screen" : "multiply"),
		_dark: color_v0.dark,
		accent: base.accent,
		avatar: base.avatar,
		backdrop: color_v0.base.shadow.ambient,
		badge: base.badge,
		bg: color_v0.base.bg,
		border: color_v0.base.border,
		button: {
			default: stateTonesThemeColor_v0_v2(color_v0, color_v0.button.default),
			ghost: stateTonesThemeColor_v0_v2(color_v0, color_v0.button.ghost),
			bleed: stateTonesThemeColor_v0_v2(color_v0, color_v0.button.bleed)
		},
		code: base.code,
		fg: color_v0.base.fg,
		focusRing: color_v0.base.focusRing,
		icon: base.muted.fg,
		input: {
			default: inputStatesThemeColor_v0_v2(color_v0.input.default),
			invalid: inputStatesThemeColor_v0_v2(color_v0.input.invalid)
		},
		kbd: base.kbd,
		link: base.link,
		muted: {
			...base.muted,
			bg: color_v0.selectable?.default.enabled.bg2 || color_v0.base.bg
		},
		selectable: stateTonesThemeColor_v0_v2(color_v0, color_v0.selectable || color_v0.muted),
		shadow: color_v0.base.shadow,
		skeleton: {
			from: color_v0.skeleton?.from || color_v0.base.border,
			to: color_v0.skeleton?.to || color_v0.base.border
		},
		syntax: color_v0.syntax
	};
	return cache$1.set(color_v0, color_v2), color_v2;
}
function stateTonesThemeColor_v0_v2(v0, t) {
	return {
		default: {
			enabled: stateThemeColor_v0_v2(v0, t.default.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.default.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.default.pressed),
			selected: stateThemeColor_v0_v2(v0, t.default.selected),
			disabled: stateThemeColor_v0_v2(v0, t.default.disabled)
		},
		neutral: {
			enabled: stateThemeColor_v0_v2(v0, t.default.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.default.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.default.pressed),
			selected: stateThemeColor_v0_v2(v0, t.default.selected),
			disabled: stateThemeColor_v0_v2(v0, t.default.disabled)
		},
		primary: {
			enabled: stateThemeColor_v0_v2(v0, t.primary.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.primary.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.primary.pressed),
			selected: stateThemeColor_v0_v2(v0, t.primary.selected),
			disabled: stateThemeColor_v0_v2(v0, t.primary.disabled)
		},
		suggest: {
			enabled: stateThemeColor_v0_v2(v0, t.primary.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.primary.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.primary.pressed),
			selected: stateThemeColor_v0_v2(v0, t.primary.selected),
			disabled: stateThemeColor_v0_v2(v0, t.primary.disabled)
		},
		positive: {
			enabled: stateThemeColor_v0_v2(v0, t.positive.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.positive.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.positive.pressed),
			selected: stateThemeColor_v0_v2(v0, t.positive.selected),
			disabled: stateThemeColor_v0_v2(v0, t.positive.disabled)
		},
		caution: {
			enabled: stateThemeColor_v0_v2(v0, t.caution.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.caution.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.caution.pressed),
			selected: stateThemeColor_v0_v2(v0, t.caution.selected),
			disabled: stateThemeColor_v0_v2(v0, t.caution.disabled)
		},
		critical: {
			enabled: stateThemeColor_v0_v2(v0, t.critical.enabled),
			hovered: stateThemeColor_v0_v2(v0, t.critical.hovered),
			pressed: stateThemeColor_v0_v2(v0, t.critical.pressed),
			selected: stateThemeColor_v0_v2(v0, t.critical.selected),
			disabled: stateThemeColor_v0_v2(v0, t.critical.disabled)
		}
	};
}
function stateThemeColor_v0_v2(v0, state) {
	return {
		...state,
		avatar: {
			gray: {
				bg: v0.spot.gray,
				fg: v0.base.bg
			},
			blue: {
				bg: v0.spot.blue,
				fg: v0.base.bg
			},
			purple: {
				bg: v0.spot.purple,
				fg: v0.base.bg
			},
			magenta: {
				bg: v0.spot.magenta,
				fg: v0.base.bg
			},
			red: {
				bg: v0.spot.red,
				fg: v0.base.bg
			},
			orange: {
				bg: v0.spot.orange,
				fg: v0.base.bg
			},
			yellow: {
				bg: v0.spot.yellow,
				fg: v0.base.bg
			},
			green: {
				bg: v0.spot.green,
				fg: v0.base.bg
			},
			cyan: {
				bg: v0.spot.cyan,
				fg: v0.base.bg
			}
		},
		badge: {
			default: {
				bg: v0.muted.default.enabled.bg,
				fg: v0.muted.default.enabled.fg,
				dot: v0.muted.default.enabled.muted.fg,
				icon: v0.muted.default.enabled.muted.fg
			},
			neutral: {
				bg: v0.muted.transparent.enabled.bg,
				fg: v0.muted.transparent.enabled.fg,
				dot: v0.muted.transparent.enabled.muted.fg,
				icon: v0.muted.transparent.enabled.muted.fg
			},
			primary: {
				bg: v0.muted.primary.enabled.bg,
				fg: v0.muted.primary.enabled.fg,
				dot: v0.muted.primary.enabled.muted.fg,
				icon: v0.muted.primary.enabled.muted.fg
			},
			suggest: {
				bg: v0.muted.primary.enabled.bg,
				fg: v0.muted.primary.enabled.fg,
				dot: v0.muted.primary.enabled.muted.fg,
				icon: v0.muted.primary.enabled.muted.fg
			},
			positive: {
				bg: v0.muted.positive.enabled.bg,
				fg: v0.muted.positive.enabled.fg,
				dot: v0.muted.positive.enabled.muted.fg,
				icon: v0.muted.positive.enabled.muted.fg
			},
			caution: {
				bg: v0.muted.caution.enabled.bg,
				fg: v0.muted.caution.enabled.fg,
				dot: v0.muted.caution.enabled.muted.fg,
				icon: v0.muted.caution.enabled.muted.fg
			},
			critical: {
				bg: v0.muted.critical.enabled.bg,
				fg: v0.muted.critical.enabled.fg,
				dot: v0.muted.critical.enabled.muted.fg,
				icon: v0.muted.critical.enabled.muted.fg
			}
		},
		kbd: {
			bg: v0.muted.default.enabled.bg,
			fg: v0.muted.default.enabled.fg,
			border: v0.muted.default.enabled.border
		},
		muted: {
			...v0.muted.default.enabled.muted,
			bg: state.bg2 || state.bg
		},
		skeleton: {
			from: state.skeleton?.from || state.border,
			to: state.skeleton?.to || state.border
		}
	};
}
function inputStatesThemeColor_v0_v2(states) {
	return {
		enabled: inputStateThemeColor_v0_v2(states.enabled),
		disabled: inputStateThemeColor_v0_v2(states.disabled),
		readOnly: inputStateThemeColor_v0_v2(states.readOnly),
		hovered: inputStateThemeColor_v0_v2(states.hovered)
	};
}
function inputStateThemeColor_v0_v2(state) {
	return {
		bg: state.bg,
		border: state.border,
		fg: state.fg,
		muted: { bg: state.bg2 },
		placeholder: state.placeholder
	};
}
const cache = /* @__PURE__ */ new WeakMap();
/** @public */
function getTheme_v2(theme) {
	if (theme.sanity.v2?._resolved) return theme.sanity.v2;
	let cached_v2 = cache.get(theme);
	if (cached_v2) return cached_v2;
	let v2 = {
		_version: 2,
		_resolved: !0,
		avatar: {
			...defaultThemeConfig.avatar,
			...theme.sanity.avatar
		},
		button: {
			...defaultThemeConfig.button,
			...theme.sanity.button
		},
		card: defaultThemeConfig.card,
		color: themeColor_v0_v2(theme.sanity.color),
		container: theme.sanity.container,
		font: theme.sanity.fonts,
		input: {
			...defaultThemeConfig.input,
			...theme.sanity.input,
			checkbox: {
				...defaultThemeConfig.input.checkbox,
				...theme.sanity.input.checkbox
			},
			radio: {
				...defaultThemeConfig.input.radio,
				...theme.sanity.input.radio
			},
			switch: {
				...defaultThemeConfig.input.switch,
				...theme.sanity.input.switch
			}
		},
		layer: theme.sanity.layer ?? defaultThemeConfig.layer,
		media: theme.sanity.media,
		radius: theme.sanity.radius,
		shadow: theme.sanity.shadows,
		space: theme.sanity.space,
		style: theme.sanity.styles
	};
	return cache.set(theme, v2), v2;
}
export { themeColor_v0_v2 as n, defaultThemeConfig as r, getTheme_v2 as t };

//# sourceMappingURL=getTheme_v2-y09KqtEb.js.map